import queryString from 'query-string';
import history from 'customHistory';

export const setUrlParams = (search = '') => {
  if (window && window.history && window.history.pushState) {
    history.push(`${window.location.pathname}${search ? `?${search}` : ''}`);
  }
};

export const getUrlParams = () =>
  queryString.parse(window.location.search) || {};

export const updateUrlParams = ({ params = {}, search }) => {
  const existingParams = getUrlParams(window.location);

  const searchString =
    search || queryString.stringify({ ...existingParams, ...params });

  setUrlParams(searchString);
};

export const createRoute = (path, name) => ({
  path,
  name,
});
